import { BooleanRadioButton, BooleanRadioButtonGroup } from "@octopusdeploy/design-system-components";
import type * as React from "react";
import { DeploymentModelType } from "~/areas/projects/components/Runbooks/RunbookRunNowLayout";
import ExpandableFormSection from "~/components/form/Sections/ExpandableFormSection";
import Summary from "~/components/form/Sections/Summary";
import { Note } from "~/components/form/index";
interface FailTargetDiscoveryOptionsProps {
    defaultFailTargetDiscovery: boolean;
    failTargetDiscovery: boolean;
    modelType: DeploymentModelType;
    onOptionChanged(value: boolean): void;
}
const FailTargetDiscoveryOptions: React.FC<FailTargetDiscoveryOptionsProps> = ({ defaultFailTargetDiscovery, failTargetDiscovery, modelType, onOptionChanged }) => {
    return (<ExpandableFormSection errorKey="failTargetDiscovery" title="Fail Target Discovery" summary={buildSummary()} help="Choose whether to fail deployment steps for target discovery steps that find no matching targets ">
            <BooleanRadioButtonGroup accessibleName="Fail Target Discovery" value={failTargetDiscovery} onChange={onOptionChanged}>
                <BooleanRadioButton value={false} label="Skip discovery steps with no matching targets" isDefault={!defaultFailTargetDiscovery}/>
                <BooleanRadioButton value={true} label="Fail discovery steps with no matching targets" isDefault={defaultFailTargetDiscovery}/>
            </BooleanRadioButtonGroup>
            <Note>Sets a default target discovery option when {modelType === DeploymentModelType.Deployment ? "deploying a release." : "running a runbook."}</Note>
        </ExpandableFormSection>);
    function buildSummary() {
        return failTargetDiscovery ? Summary.summary("Fail discovery steps with no matching targets") : Summary.default("Skip discovery steps with no matching targets");
    }
};
FailTargetDiscoveryOptions.displayName = "FailTargetDiscoveryOptions"
export default FailTargetDiscoveryOptions;
